import { render } from "./WorkspaceItems.vue?vue&type=template&id=75c49c84&scoped=true"
import script from "./WorkspaceItems.vue?vue&type=script&lang=js"
export * from "./WorkspaceItems.vue?vue&type=script&lang=js"

import "./WorkspaceItems.vue?vue&type=style&index=0&id=75c49c84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c49c84"]])

export default __exports__